var exports = {
  "kL": "FormSwitch.module__container___ZEdxT3",
  "oE": "FormSwitch.module__compact___ZEdxT3",
  "_A": "FormSwitch.module__labelContainer___ZEdxT3",
  "Pf": "FormSwitch.module__label___ZEdxT3",
  "r9": "FormSwitch.module__disabled___ZEdxT3",
  "vk": "FormSwitch.module__clickable___ZEdxT3",
  "h_": "FormSwitch.module__description___ZEdxT3",
  "HV": "FormSwitch.module__switchRoot___ZEdxT3",
  "L8": "FormSwitch.module__switchThumb___ZEdxT3",
  "nL": "FormSwitch.module__iconChecked___ZEdxT3",
  "ao": "FormSwitch.module__iconUnchecked___ZEdxT3",
};

module.exports = exports;
